import React from 'react';
import DefaultButton from '../../../atoms/Buttons/DefaultButton';
import { ButtonProps } from '@mui/material';

type IconOnlyButtonProps = {
  icon: React.ReactNode;
} & ButtonProps;

export default function IconOnlyButton({
  icon,
  ...buttonProps
}: IconOnlyButtonProps) {
  return <DefaultButton {...buttonProps}>{icon}</DefaultButton>;
}
